import React, { useState, useEffect } from "react";
import classes from './Payment.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import { useLocation, useNavigate } from "react-router-dom";
import svg from "../../Assets/SVG.jpg";
import { Trash } from "lucide-react";
import swal from "sweetalert";
import Swal from "sweetalert2";
import filter from "../../Assets/SVG (1).png";
import exports from "../../Assets/file-export.png";
import vector from "../../Assets/Vector.svg";
import invoice from "../../Assets/invoice-04.png";
import date from "../../Assets/SVG (2).png";
import exported from "../../Assets/SVG (4).png";
import Footer from "../../Components/Footer/Footer";
import api, { withCompanyId } from "../../Components/API/Api";
import SalaryStructureSet from "./Set Salary Structure/SalarystructureSet";

const SalaryStructure = () => {
    const location = useLocation();
    const navigate = useNavigate();

    // store salary structures fetched from /v1/payroll/salary_structure/get_specified
    const [salaryStructures, setSalaryStructures] = useState([]);
    // Removed old salaryStructures state (we use groupedStructures)

    const [isUpdating, setIsUpdating] = useState(false);
    // view only modal state
    const [viewOpen, setViewOpen] = useState(false);
    const [viewStructure, setViewStructure] = useState(null);
    const [viewAllowances, setViewAllowances] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isNewModalOpen, setIsNewModalOpen] = useState(false);
    // removed unused modals
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [viewAllowancesLoading, setViewAllowancesLoading] = useState(false);
    const [viewAllowancesError, setViewAllowancesError] = useState("");
    // edit modal state & form
    const [editOpen, setEditOpen] = useState(false);
    const [editingEmployee, setEditingEmployee] = useState(null);
    const [editForm, setEditForm] = useState({
        first_name: "",
        last_name: "",
        sex: "",
        employee_id: "",
        home_address: "",
        nin: "",
        email: "",
        phone_no: "",
        dob: "",
        marital_status: "",
        department: "",
        unit: "",
        employment_type: "",
        job_title: "",
        grade: "",
        step: "",
        date_of_first_appointment: "",
        manager_name: "",
        employment_status: "",
        bank_name: "",
        account_number: "",
        basic_salary: "",
        next_of_kin_name: "",
        relationship: "",
        next_of_kin_phone: "",
        next_of_kin_address: "",
        photo: ""
    });
    const [editErrors, setEditErrors] = useState({});
    const [selectMetrics, setSelectedMetrics] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openCashReciept, setOpenCashReciept] = useState(false);
    const [openAllowanceModal, setOpenAllowanceModal] = useState(false);
    const [loading, setLoading] = useState(true);

    // state to track the selected allowance or group for deletion
    const [selectedLocation, setSelectedLocation] = useState(null);

    const [baseCurrencyCode, setBaseCurrencyCode] = useState("NGN");



    useEffect(() => {
        const getBaseCurrencyCode = async () => {
            try {
                const token = localStorage.getItem("authToken");


                const companyRes = await api.get(`/v1/companies/get-info`);

                const companyData = Array.isArray(companyRes?.data?.data)
                    ? companyRes.data.data[0]
                    : companyRes?.data?.data;

                const currencyId = companyData?.currency_base;


                const currenciesRes = await api.get('/v1/fetch-all-currencies');

                if (currenciesRes.data?.data && Array.isArray(currenciesRes.data.data)) {

                    const baseCurrency = currenciesRes.data.data.find(
                        currency => String(currency.id) === String(currencyId)
                    );

                    if (baseCurrency && baseCurrency.code) {
                        setBaseCurrencyCode(baseCurrency.code);
                    } else {
                        setBaseCurrencyCode("NGN");
                    }
                }

            } catch (err) {
                console.error("Failed to fetch base currency", err);
                setBaseCurrencyCode("NGN"); // Fallback
            }
        };

        getBaseCurrencyCode();
    }, []);
    // fetch salary structures
    const fetchSalaryStructures = async () => {
        try {
            setLoading(true);
            const res = await api.get('/v1/payroll/salary_structure/get_specified');
            const result = Array.isArray(res?.data?.data) ? res.data.data : [];
            setSalaryStructures(result);
        } catch (error) {
            console.error("Error fetching salary structures:", error);
            setSalaryStructures([]);
        } finally {
            setLoading(false);
        }
    };
    // fetchSalaryStructures removed: we use fetchSalaryAllowances instead

    const openDeleteModal = (target) => {
        // target can be a group (with allowances array) or a single allowance object
        setSelectedLocation(target);
        setIsDeleteModalOpen(true);
    };

    // Updated delete handler to support single allowance or group deletion
    const handleDelete = async () => {
        if (!selectedLocation) return;
        setDeleting(true);

        try {
            const token = localStorage.getItem("authToken");

            // Prepare array of ids to delete: if group, delete all allowances in the group; else single id
            const idsToDelete = Array.isArray(selectedLocation?.allowances)
                ? selectedLocation.allowances.map(a => a.id).filter(Boolean)
                : [selectedLocation?.id].filter(Boolean);

            // If nothing to delete, show warning
            if (idsToDelete.length === 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Nothing to delete",
                    text: "No allowance(s) found to delete."
                });
                setIsDeleteModalOpen(false);
                setSelectedLocation(null);
                setDeleting(false);
                return;
            }

            // Fire the deletion requests (the API uses GET with id param)
            await Promise.all(idsToDelete.map(id =>
                api.get('/v1/salary_allowance/delete', { params: { id } })
            ));

            // close modal and refresh
            setIsDeleteModalOpen(false);
            setSelectedLocation(null);
            fetchSalaryAllowances(); // Refresh the list

            Swal.fire({
                icon: "success",
                title: "Deleted",
                text: `Deleted ${idsToDelete.length} allowance(s) successfully.`,
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Failed to delete allowance(s).";
            Swal.fire({
                icon: "error",
                title: "Failed to Delete",
                text: errorMessage
            });
            console.error("Delete error:", error);
        } finally {
            setDeleting(false);
        }
    };

    // Add a helper to delete a single allowance directly (used in the View modal)
    const handleDeleteSingleAllowance = async (allowance) => {
        if (!allowance?.id) return;
        setDeleting(true);
        try {
            await api.get('/v1/salary_allowance/delete', { params: { id: allowance.id } });
            fetchSalaryAllowances();
            Swal.fire({ icon: "success", title: "Deleted", text: "Allowance deleted", timer: 2000, showConfirmButton: false });
        } catch (error) {
            const errorMessage = error?.response?.data?.message || "Failed to delete allowance.";
            Swal.fire({ icon: "error", title: "Failed", text: errorMessage });
            console.error("Delete single allowance error:", error);
        } finally {
            setDeleting(false);
        }
    };

    // New state for salary allowances
    const [salaryAllowances, setSalaryAllowances] = useState([]);
    // Grouped data for table: [{grade, step, allowances: [], totalAmount}]
    const [groupedStructures, setGroupedStructures] = useState([]);

    // Fetch salary allowances and group by grade  step
    const fetchSalaryAllowances = async () => {
        try {
            setLoading(true);
            const res = await api.get('/v1/salary_allowance/get-all');
            const result = Array.isArray(res?.data?.data) ? res.data.data : [];
            setSalaryAllowances(result);

            // Group by grade_id    step_id
            const groupMap = {};
            result.forEach(item => {
                const gradeId = item.grade?.id || item.grade_id;
                const stepId = item.step?.id || item.step_id;
                const key = `${gradeId}_${stepId}`;
                if (!groupMap[key]) {
                    groupMap[key] = {
                        grade: item.grade,
                        step: item.step,
                        allowances: [],
                        totalAmount: 0
                    };
                }
                groupMap[key].allowances.push(item);
                // accumulate allowance amount for the group
                groupMap[key].totalAmount += Number(item.amount || 0);
            });
            setGroupedStructures(Object.values(groupMap));
        } catch (error) {
            console.error("Error fetching salary allowances:", error);
            setSalaryAllowances([]);
            setGroupedStructures([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSalaryAllowances();
    }, []);



    const allSelected = selectedRows.length === salaryStructures.length;

    const handleSelectAll = () => {
        if (allSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(salaryStructures.map((_, i) => i));
        }
    };

    const handleSelectRow = (index) => {
        if (selectedRows.includes(index)) {
            setSelectedRows(selectedRows.filter((i) => i !== index));
        } else {
            setSelectedRows([...selectedRows, index]);
        }
    };
    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
    };

    // open employee detail (passes employee object via router state)
    const handleOpenReceipt = (structure) => {
        navigate('/employee-detail', { state: { structure } });
    };
    // removed handleOpenReceipt (not used)

    // open view only modal (non editable)
    const fetchAllowancesForStructure = async (gradeId, stepId) => {
        if (!gradeId || !stepId) {
            setViewAllowances([]);
            setViewAllowancesError("Grade and step information are required to fetch allowances.");
            return;
        }
        try {
            setViewAllowancesLoading(true);
            setViewAllowancesError("");
            const res = await api.get('/v1/salary_allowance/get-by-gradeandstep', {
                params: {
                    grade_id: gradeId,
                    step_id: stepId
                }
            });
            const data = res?.data?.data;
            if (Array.isArray(data)) {
                setViewAllowances(data);
            } else if (data) {
                setViewAllowances([data]);
            } else {
                setViewAllowances([]);
            }
        } catch (error) {
            const msg = error?.response?.data?.message;
            if (msg && typeof msg === "object") {
                const combined = Object.values(msg).flat().join(" ");
                setViewAllowancesError(combined || "Failed to fetch allowances.");
            } else {
                setViewAllowancesError(error?.response?.data?.message || "Failed to fetch allowances.");
            }
            setViewAllowances([]);
        } finally {
            setViewAllowancesLoading(false);
        }
    };
    // fetchAllowancesForStructure removed; we use grouped structure allowances and fetchSalaryAllowances()

    // open view only modal (non editable)
    const handleViewClick = (structure) => {
        setViewStructure(structure);
        setViewOpen(true);
        setViewAllowances(structure.allowances || []);
        setViewAllowancesError("");
    };

    // populate edit form and open modal
    const handleEditClick = (emp) => {
        setEditingEmployee(emp);
        setEditErrors({});
        setEditForm({
            first_name: emp.first_name || "",
            last_name: emp.last_name || "",
            sex: emp.sex || "",
            employee_id: emp.employee_id || "",
            home_address: emp.home_address || "",
            nin: emp.nin || "",
            email: emp.email || "",
            phone_no: emp.phone_no || "",
            dob: emp.dob || "",
            marital_status: emp.marital_status || "",
            department: emp.department || "",
            unit: emp.unit || "",
            employment_type: emp.employment_type || (emp.emp_type?.id ? String(emp.emp_type.id) : ""),
            job_title: emp.job_title || "",
            grade: emp.grade || "",
            step: emp.step || "",
            date_of_first_appointment: emp.date_of_first_appointment || "",
            manager_name: emp.manager_name || "",
            employment_status: emp.employment_status || (emp.emp_status?.id ? String(emp.emp_status.id) : ""),
            bank_name: emp.bank_name || "",
            account_number: emp.account_number || "",
            basic_salary: emp.basic_salary || "",
            next_of_kin_name: emp.next_of_kin_name || "",
            relationship: emp.relationship || "",
            next_of_kin_phone: emp.next_of_kin_phone || "",
            next_of_kin_address: emp.next_of_kin_address || "",
            photo: emp.photo || ""
        });
        setEditOpen(true);
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;

        // Ensure pay_basic is stored as id
        if (name === "pay_basic") {
            setEditForm(prev => ({ ...prev, [name]: parseInt(value, 10) }));
        } else {
            setEditForm(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleUpdateEmployee = async () => {
        if (!editingEmployee) return;
        setIsUpdating(true);
        try {
            const payload = { id: editingEmployee.id, ...editForm };
            const res = await api.post('/v1/employee/update', withCompanyId(payload));
            // if server returns validation errors under message.error
            if (res?.data?.message && res.data.message.error) {
                setEditErrors(res.data.message.error);
                return;
            }
            // update local state: replace the updated employee
            const updated = Array.isArray(res?.data?.data) ? res.data.data : res?.data?.data || null;
            // the API might return the updated record, otherwise merge form into local object
            const updatedEmp = updated || { ...editingEmployee, ...editForm };
            // setEmployees(prev => prev.map(e => (e.id === editingEmployee.id ? updatedEmp : e)));
            setEditOpen(false);
            setEditingEmployee(null);
            setEditErrors({});
            // show swal success alert
            swal("Success", "Employee updated successfully.", "success");
        } catch (err) {
            // try to read validation errors if present
            if (err?.response?.data?.message?.error) {
                setEditErrors(err.response.data.message.error);
            } else {
                console.error("Failed to update employee", err);
            }
        } finally {
            setIsUpdating(false);
        }
    };

    // single line ellipsis style for table cells
    const ellipsisStyle = {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: 180,
        display: "block",
        cursor: "pointer"
    };

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname]} />

            <div className={classes.Container}>
                <div className={classes.actions}>
                    <button className={classes.btns}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
                </div>

                <header className={classes.Header}>
                    <h2 className={classes.Title}>Salary Structure</h2>
                    <h1 className={classes.Titles}>
                        View all Employee Records and and payments in chronological order.
                    </h1>
                </header>

                {/* === Metrics Cards === */}
                <div className={classes.entrjj}>
                    <div className={classes.allkads}>
                        <div className={classes.thrdkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total debits</p>
                                <p className={classes.kdptg1}>
                                    {selectMetrics?.total_debits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frtkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Total Credits</p>
                                <p className={classes.kdptg2}>
                                    {selectMetrics?.total_credits?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This period</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.fiftkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Trial balance</p>
                                <p className={classes.kdptg3}>
                                    {selectMetrics?.trial_balance?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>Balanced</p>
                                </div>
                            </div>
                        </div>

                        <div className={classes.frstkad}>
                            <div className={classes.kad}>
                                <p className={classes.kdptg}>Entries</p>
                                <p className={classes.kdptg4}>
                                    {selectMetrics?.total_entries?.toLocaleString() ?? "0"}
                                </p>
                                <div className={classes.rvnue}>
                                    <p className={classes.skaltxt}>This month</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* === Header Actions === */}
                <div className={classes.headerActions}>
                    <div className={classes.actionsRight}>
                        <div className={classes.inputWrapper}>
                            <img src={svg} alt="svg" className={classes.searchIcon} />
                            <input type="text" className={classes.searchBar} placeholder="Search ledger..." />
                        </div>

                        <div className={classes.selectWrapper}>
                            <select className={classes.dropdown}>
                                <option value="">All accounts</option>
                                <option value="Paid">Paid</option>
                                <option value="Pending">Pending</option>
                                <option value="Overdue">Overdue</option>
                                <option value="Draft">Draft</option>
                            </select>
                            <span className={classes.dropdownArrow}>▼</span>
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={date} alt="date" className={classes.dateicon} />
                            <input type="text" className={classes.thirdBar} placeholder="Date Range" />
                        </div>

                        <div className={classes.inputWrapper}>
                            <img src={filter} alt="Filter" className={classes.filterIcon} />
                            <input type="text" className={classes.secondBar} placeholder="Filter" />
                        </div>
                    </div>

                    <div className={classes.inputWrapper} style={{ display: "flex", gap: 12 }}>
                        <button className={classes.btnss} onClick={() => setOpenCashReciept(true)}>
                            <img src={exported} alt="added" className={classes.invoiceIcon} />
                            Set Basic Salary
                        </button>
                        <button className={classes.btnss} onClick={() => setOpenAllowanceModal(true)}>
                            <img src={exported} alt="added" className={classes.invoiceIcon} />
                            Set Allowances
                        </button>
                    </div>
                </div>

                {/* === Payments Table === */}
                <div className={classes.tableContainer}>
                    <table className={classes.table}>
                        <thead>
                            <tr className={classes.tableHeader}>
                                <th>S/N</th>
                                <th>Grade</th>
                                <th>Step</th>
                                <th>Basic Salary</th>
                                <th>Allowances</th>
                                <th>Actions</th> {/* Added Actions header to match the extra column */}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                // Skeleton loader — 9 rows, 6 columns
                                Array.from({ length: 9 }).map((_, rowIndex) => (
                                    <tr key={rowIndex}>
                                        {[...Array(6)].map((_, colIndex) => (
                                            <td key={colIndex}>
                                                <div className={classes.skeletonBox}></div>
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            ) : Array.isArray(groupedStructures) && groupedStructures.length > 0 ? (
                                groupedStructures.map((group, index) => (
                                    <tr key={`${group.grade?.id}_${group.step?.id}`}>
                                        <td>
                                            <div style={ellipsisStyle} title={`#${index + 1}`}>
                                                {index + 1}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={ellipsisStyle} title={group.grade?.description || "—"}>
                                                {group.grade?.description || "—"}
                                            </div>
                                        </td>
                                        <td>
                                            <div style={ellipsisStyle} title={group.step?.description || "—"}>
                                                {group.step?.description || "—"}
                                            </div>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                            <div style={{ ...ellipsisStyle, textAlign: "right", maxWidth: 140 }} title={group.totalAmount ? `${Number(group.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${baseCurrencyCode}` : "—"}>
                                                {group.totalAmount ? Number(group.totalAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "—"} {group.totalAmount ? baseCurrencyCode : ""}
                                            </div>
                                        </td>
                                        <td className={`${classes.tableCell} ${classes.iconActions}`}>
                                            <span
                                                onClick={() => handleViewClick(group)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') handleViewClick(group); }}
                                                style={{ margin: "0 8px", color: "rgb(37, 99, 235)", cursor: "pointer" }}
                                                aria-label={`View allowances for ${group.grade?.description || ''} ${group.step?.description || ''}`}
                                            >
                                                <p className={classes.viewAllowances}>View Allowances{Array.isArray(group.allowances) ? ` (${group.allowances.length})` : ''}</p>
                                            </span>
                                        </td>

                                        {/* Actions column: delete group allowances */}
                                        <td className={classes.actionsCell}>
                                            <div className={classes.actionIcons}>
                                                <Trash
                                                    size={16}
                                                    className={classes.deleteActionIcon}
                                                    onClick={() => openDeleteModal(group)}
                                                    title="Delete all allowances for this grade/step"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center" }}>
                                        No salary structures found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Edit modal (simple inline modal) */}
                {editOpen && (
                    <div style={{
                        position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
                    }} onClick={() => { setEditOpen(false); setEditingEmployee(null); setEditErrors({}); }}>
                        <div style={{ width: 820, maxHeight: "85vh", overflowY: "auto", background: "#fff", padding: 20 }} onClick={(e) => e.stopPropagation()}>
                            <h3 style={{ marginTop: 0 }}>Edit employee</h3>
                            {/* show global errors if any */}
                            {editErrors && Object.keys(editErrors).length > 0 && (
                                <div style={{ color: "red", marginBottom: 8 }}>
                                    {Object.entries(editErrors).map(([k, v]) => (
                                        <div key={k}><strong>{k}:</strong> {(Array.isArray(v) ? v.join(", ") : v)}</div>
                                    ))}
                                </div>
                            )}
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
                                <input name="first_name" placeholder="First name" value={editForm.first_name} onChange={handleEditChange} />
                                <input name="last_name" placeholder="Last name" value={editForm.last_name} onChange={handleEditChange} />
                                <input name="sex" placeholder="Sex" value={editForm.sex} onChange={handleEditChange} />
                                <input name="employee_id" placeholder="Employee ID" value={editForm.employee_id} onChange={handleEditChange} />
                                <input name="phone_no" placeholder="Phone" value={editForm.phone_no} onChange={handleEditChange} />
                                <input name="email" placeholder="Email" value={editForm.email} onChange={handleEditChange} />
                                <input name="department" placeholder="Department" value={editForm.department} onChange={handleEditChange} />
                                <input name="unit" placeholder="Unit" value={editForm.unit} onChange={handleEditChange} />
                                <input name="home_address" placeholder="Home address" value={editForm.home_address} onChange={handleEditChange} />
                                <input name="nin" placeholder="NIN" value={editForm.nin} onChange={handleEditChange} />
                                <input name="dob" placeholder="DOB (YYYY MM DD)" value={editForm.dob} onChange={handleEditChange} />
                                <input name="marital_status" placeholder="Marital status" value={editForm.marital_status} onChange={handleEditChange} />
                                <input name="job_title" placeholder="Job title" value={editForm.job_title} onChange={handleEditChange} />
                                <input name="manager_name" placeholder="Manager name" value={editForm.manager_name} onChange={handleEditChange} />
                                <input name="basic_salary" placeholder="Basic salary" value={editForm.basic_salary} onChange={handleEditChange} />
                                <input name="bank_name" placeholder="Bank name" value={editForm.bank_name} onChange={handleEditChange} />
                                <input name="account_number" placeholder="Account number" value={editForm.account_number} onChange={handleEditChange} />
                                <input name="next_of_kin_name" placeholder="Next of kin name" value={editForm.next_of_kin_name} onChange={handleEditChange} />
                                <input name="next_of_kin_phone" placeholder="Next of kin phone" value={editForm.next_of_kin_phone} onChange={handleEditChange} />
                                <input name="next_of_kin_address" placeholder="Next of kin address" value={editForm.next_of_kin_address} onChange={handleEditChange} />
                                <input name="photo" placeholder="Photo URL" value={editForm.photo} onChange={handleEditChange} />
                            </div>
                            <div style={{ marginTop: 12, display: "flex", gap: 8, justifyContent: "flex-end" }}>
                                <button onClick={() => { setEditOpen(false); setEditingEmployee(null); setEditErrors({}); }}>Cancel</button>
                                <button
                                    className={classes.saveBtn}
                                    onClick={handleUpdateEmployee}
                                    disabled={isUpdating}
                                    style={{ background: "#16a34a", color: "#fff", border: "none", padding: "8px 12px", borderRadius: 6, cursor: isUpdating ? "not-allowed" : "pointer" }}
                                >
                                    {isUpdating ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* View Allowances modal (opened by clicking View Allowances) */}
                {viewOpen && viewStructure && (
                    <div style={{
                        position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
                        display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
                    }} onClick={() => { setViewOpen(false); setViewStructure(null); setViewAllowances([]); setViewAllowancesError(""); }}>
                        <div style={{ width: 720, maxHeight: "85vh", overflowY: "auto", background: "#fff", padding: 20, borderRadius: 8 }} onClick={(e) => e.stopPropagation()}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                                <h3 style={{ margin: 0 }}>Allowances</h3>
                                <button onClick={() => { setViewOpen(false); setViewStructure(null); setViewAllowances([]); setViewAllowancesError(""); }} style={{ fontSize: 18, lineHeight: 1, border: "none", background: "transparent", cursor: "pointer" }}>×</button>
                            </div>

                            <div style={{ marginBottom: 12, color: "#374151" }}>
                                <div><strong>Grade:</strong> {viewStructure?.grade?.description || "—"}</div>
                                <div><strong>Step:</strong> {viewStructure?.step?.description || "—"}</div>
                                <div><strong>Basic Salary:</strong> {viewStructure?.basic_salary ? `${Number(viewStructure.basic_salary).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${baseCurrencyCode}` : "—"}</div>
                            </div>

                            <table className={classes.table}>
                                <thead>
                                    <tr className={classes.tableHeader}>
                                        <th style={{ textAlign: "left" }}>#</th>
                                        <th style={{ textAlign: "left" }}>Allowance</th>
                                        <th style={{ textAlign: "right" }}>Amount</th>
                                        <th style={{ textAlign: "center" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viewAllowancesLoading ? (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>Loading allowances...</td>
                                        </tr>
                                    ) : viewAllowancesError ? (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center", color: "red" }}>{viewAllowancesError}</td>
                                        </tr>
                                    ) : Array.isArray(viewAllowances) && viewAllowances.length > 0 ? (
                                        viewAllowances.map((alw, idx) => {
                                            const allowanceName =
                                                alw?.type?.description ||
                                                alw?.type?.name ||
                                                alw?.allowance_type?.description ||
                                                alw?.allowance_type?.name ||
                                                alw?.allowance_type ||
                                                alw?.description ||
                                                alw?.name ||
                                                "—";
                                            const allowanceAmount =
                                                alw?.amount ?? alw?.allowance_amount ?? alw?.value ?? alw?.total ?? null;
                                            return (
                                                <tr key={alw.id || idx}>
                                                    <td>{idx + 1}</td>
                                                    <td>
                                                        <div style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 280 }} title={allowanceName}>
                                                            {allowanceName}
                                                        </div>
                                                    </td>
                                                    <td style={{ textAlign: "right" }}>
                                                        {allowanceAmount !== null && allowanceAmount !== undefined
                                                            ? `${Number(allowanceAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${baseCurrencyCode}`
                                                            : "—"}
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <Trash
                                                            size={16}
                                                            className={classes.deleteActionIcon}
                                                            onClick={() => openDeleteModal(alw)} // open modal for single allowance deletion
                                                            title="Delete allowance"
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="4" style={{ textAlign: "center" }}>No allowances found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            <div style={{ marginTop: 12, display: "flex", justifyContent: "flex-end" }}>
                                <button onClick={() => { setViewOpen(false); setViewStructure(null); }} style={{ padding: "8px 12px", borderRadius: 6, border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}>Close</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Delete Allowance  Modal */}
                {isDeleteModalOpen && (
                    <div className={classes.modalModalOverlay}>
                        <div className={classes.modalModalDeleteContent}>
                            <div className={classes.modalModalHeader}>
                                <h2 style={{ marginBottom: "auto" }}>
                                    {Array.isArray(selectedLocation?.allowances) ? "Delete Allowances" : "Delete Allowance"}
                                </h2>
                                <button
                                    className={classes.closeModalBtn}
                                    onClick={() => {
                                        setIsDeleteModalOpen(false);
                                        setSelectedLocation(null);
                                    }}
                                >
                                    &times;
                                </button>
                            </div>

                            <div className={classes.modalModalBodyText00}>
                                <p>
                                    Are you sure you want to delete {Array.isArray(selectedLocation?.allowances) ? "all allowances for this grade/step" : "this allowance"}?
                                    <br />This action cannot be undone.
                                </p>
                                <div className={classes.modalFormDelFooter}>
                                    <button
                                        className={classes.ModalDeleteBtn0}
                                        onClick={handleDelete}
                                        disabled={deleting}
                                    >
                                        {deleting ? "Deleting..." : "Delete"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                )}

                {/* Re-add Set Basic Salary and Set Allowances modals */}
                <SalaryStructureSet
                    mode="structure"
                    isOpen={openCashReciept}
                    onClose={() => setOpenCashReciept(false)}
                    onSuccess={() => {
                        fetchSalaryAllowances(); // refresh allowances after save
                        setOpenCashReciept(false);
                    }}
                />
                <SalaryStructureSet
                    mode="allowances"
                    isOpen={openAllowanceModal}
                    onClose={() => setOpenAllowanceModal(false)}
                    onSuccess={() => {
                        fetchSalaryAllowances(); // refresh allowances after save
                        setOpenAllowanceModal(false);
                    }}
                />
            </div>
            <Footer />
        </div>
    );
};

export default SalaryStructure;
